import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../redux/store'

export const retrieveLexicalCodes = createAsyncThunk<
  Record<string, string[]>,
  void,
  ThunkConfig
>('simulation/retrieveLexicalCodes', async (_, { extra }) => {
  const lexicalCodes = await extra.simulationGateway.fetchLexicalCodes()
  return lexicalCodes
})
